import { Button, Modal, TextField, FormLayout, Form, LegacyStack, LegacyCard } from '@shopify/polaris';
import { useState, useCallback } from 'react';

export const NewCustomerModal = ({ onAddCustomer, disable }) => {
  const [active, setActive] = useState(false);
  const handleChange = useCallback(() => setActive(!active), [active]);

  const dataFormDefault = {
    name: '',
    vat: '',
    email: '',
    address: '',
    country: '',
    city: '',
    state: '',
    zip: '',
    phone: '',
    pvfExpression: 'PVP/2.4',
  };

  const [dataForm, setDataForm] = useState(dataFormDefault);

  const activator = (
    <Button onClick={handleChange} primary="primary" disabled={disable} size="slim">
      Nuevo cliente
    </Button>
  );

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      await onAddCustomer(dataForm);
      setDataForm(dataForm);
      setActive(false);
    } catch (e) {}
  };

  return (
    <Modal activator={activator} open={active} onClose={handleChange} title="Crear nuevo cliente">
      <Modal.Section>
        <Form onSubmit={handleSubmit}>
          <FormLayout>
            <LegacyCard.Section title="Identificación">
              <TextField
                type="name"
                label="Nombre"
                placeholder={dataForm.name}
                value={dataForm.name}
                onChange={(e) => {
                  setDataForm({
                    ...dataForm,
                    name: e,
                  });
                }}
                autoComplete="off"
              />
              <TextField
                type="name"
                label="Email"
                placeholder={dataForm.email}
                value={dataForm.email}
                onChange={(e) => {
                  setDataForm({
                    ...dataForm,
                    email: e,
                  });
                }}
                autoComplete="off"
              />
              <LegacyStack distribution="fillEvenly">
                <TextField
                  type="name"
                  label="ID Fiscal RFC"
                  placeholder={dataForm.vat}
                  value={dataForm.vat}
                  onChange={(e) => {
                    setDataForm({
                      ...dataForm,
                      vat: e,
                    });
                  }}
                  autoComplete="off"
                />

                <TextField
                  type="name"
                  label="Teléfono"
                  placeholder={dataForm.phone}
                  value={dataForm.phone}
                  onChange={(e) => {
                    setDataForm({
                      ...dataForm,
                      phone: e,
                    });
                  }}
                  autoComplete="off"
                />
              </LegacyStack>
            </LegacyCard.Section>
            <LegacyCard.Section title="Dirección">
              <LegacyStack distribution="fillEvenly">
                <TextField
                  type="name"
                  label="Dirección"
                  placeholder={dataForm.address}
                  value={dataForm.address}
                  onChange={(e) => {
                    setDataForm({
                      ...dataForm,
                      address: e,
                    });
                  }}
                  autoComplete="off"
                />

                <TextField
                  type="name"
                  label="Zip"
                  placeholder={dataForm.zip}
                  value={dataForm.zip}
                  onChange={(e) => {
                    setDataForm({
                      ...dataForm,
                      zip: e,
                    });
                  }}
                  autoComplete="off"
                />

                <TextField
                  type="name"
                  label="Ciudad"
                  placeholder={dataForm.city}
                  value={dataForm.city}
                  onChange={(e) => {
                    setDataForm({
                      ...dataForm,
                      city: e,
                    });
                  }}
                  autoComplete="off"
                />

                <TextField
                  type="name"
                  label="Provincia"
                  placeholder={dataForm.state}
                  value={dataForm.state}
                  onChange={(e) => {
                    setDataForm({
                      ...dataForm,
                      state: e,
                    });
                  }}
                  autoComplete="off"
                />

                <TextField
                  type="name"
                  label="País"
                  placeholder={dataForm.country}
                  value={dataForm.country}
                  onChange={(e) => {
                    setDataForm({
                      ...dataForm,
                      country: e,
                    });
                  }}
                  autoComplete="off"
                />
              </LegacyStack>
            </LegacyCard.Section>
            <LegacyCard.Section title="Relación comercial">
              <TextField
                label="PVF = "
                value={dataForm.pvfExpression}
                onChange={(e) => {
                  setDataForm({
                    ...dataForm,
                    pvfExpression: e,
                  });
                }}
              />
            </LegacyCard.Section>
            <LegacyCard.Section>
              <LegacyStack distribution="center">
                <Button primary submit size="slim">
                  CREAR
                </Button>
              </LegacyStack>
            </LegacyCard.Section>
          </FormLayout>
        </Form>
      </Modal.Section>
    </Modal>
  );
};
